import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import CommonLoader from '../../../components/common-loader/CommonLoader';
import { useProject } from '../../../context/ProjectContext';

function LoaderController() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { actions } = useProject();

  const { size, page } = useSelector((state) => state.aiStudio.favoriteTableSettings);
  const isLoading = useSelector((state) => state.aiStudio.isFavoriteMediaLoading);

  useEffect(() => {
    actions('getFavoriteMedia', { projectId: id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size, page]);

  return <CommonLoader isLoading={isLoading} />;
}

export default LoaderController;
